var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
}; // TODO: Learn more typescript to get rid of 'any's and some of these interfaces
// seem like they're circular dependencies or something? Idk.


import { createGlobalStyle, css } from 'styled-components';
var CHANNEL_LENGTH = 2;
var COLOR_MOD = 5;
var COLOR_MOD_SPACING = 3;
var COLOR_LEVEL_STEP = 8; // color levels step 8%

var FONT_REM_SIZE = 16;
var HEX_BASE = 16; // Theming variables for component styles
// TODO: So what do we do about embedding and allowing re-styling? Maybe styled
//       components aren't for us? This would let us do crazy things like
//       setting the theme from a database record though. The embedded
//       components might not be able to be overridden this way though because
//       of the generated classes... hmm...

/* =========================== THEMING VARIABLES ============================ */
// Theme colors

export var colors = {
  // Fiducius colors
  // Original https://coolors.co/f96302-709302-54616a-394648-69995d
  primary: '#ff774d',
  secondary: '#18bc70',
  tertiary: '#6796eb',
  quaternary: '#4c4e61',
  quinary: '#69995d',
  primaryA: '#ff774d',
  primaryB: '#ff774d',
  // Text Colors
  textPrimary: '#212121',
  textSecondary: '#494949',
  textTertiary: '#727272',
  // Status Colors
  success: '#39ae54',
  danger: '#df4554',
  warning: '#d6a206',
  info: '#2aa9be',
  lowContrast: '#f8f9fa',
  highContrast: '#343a40',
  white: '#ffffff',
  black: '#000000',
  // Background depth levels
  // https://coolors.co/ffffff-f5f5f5-eeeeee-e6e6e6-dfdfdf
  level0: '#ffffff',
  level1: '#f5f5f5',
  level2: '#eeeeee',
  level3: '#e6e6e6',
  level4: '#dfdfdf',
  level5: '#f5f5f5',
  level0B: '#ffffff',
  level1B: '#f5f5f5',
  level2B: '#eeeeee',
  level3B: '#e6e6e6',
  level4B: '#dfdfdf',
  level5B: '#f5f5f5'
}; // Media breakpoints

export var breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
}; // Borders

var borders = {
  borderWidth: '1px',
  borderRadius: '3px',
  buttonBorderRadious: '25px',
  cardBorderRadius: '16.5px',
  borderRadiusBadge: '10rem'
}; // Box shadows

var boxShadows = {
  boxShadowSmallSpacer: 'calc(.125rem + 2px)',
  boxShadowSpacer: 'calc(.5rem + 2px)',
  boxShadowLargeSpacer: 'calc(1rem + 2px)',
  boxShadowSmall: '0 .125rem .25rem rgba(0,0,0,.075)',
  boxShadow: '0 .5rem 1rem rgba(0,0,0,.15)',
  boxShadowLarge: '0 1rem 3rem rgba(0,0,0,.175)',
  boxShadowNew: '0 5px 11px 0 rgba(0, 0, 0, 0.24)'
}; // Font settings

var font = {
  fontFamilyBase: 'font-family-sans-serif',
  fontFamilySansSerif: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  fontFamilyMonospace: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  fontWeightLighter: 'lighter',
  fontWeightLight: '300',
  fontWeightNormal: '400',
  fontWeightBold: '700',
  fontWeightBolder: 'bolder',
  lineHeightBase: '1.5',
  fontSizeBase: '1rem',
  fontSizeDisplay: '2rem',
  fontSizeLg: '1.25rem',
  fontSizeSm: '0.875rem'
}; // Input settings

var input = {
  inputFocusShadow: '0 0 0 2px',
  inputPaddingX: '.75rem',
  inputPaddingY: '.75rem'
}; // Layout settings
// TODO: Set up the sidebar to work somehow on mobile

var layout = {
  cardSpacerX: '1.25em',
  cardSpacerY: '1em',
  contentWidthXs: 'calc(100% - 100px)',
  contentWidthSm: 'calc(100% - 175px)',
  contentWidthMd: 'calc(100% - 230px)',
  contentWidthXl: 'calc(100% - 300px)',
  fluid: true,
  fullHeight: 'calc(100% - 4.6rem)',
  maxUndrawHeight: '20rem',
  sideBarWidthXs: '100px',
  sideBarWidthSm: '175px',
  sideBarWidthMd: '230px',
  sideBarWidthXl: '300px',
  topBarHeight: '4.6rem'
};
/* =========================== THEMING FUNCTIONS ============================ */
// Color mix function ported from sass

var mix = function mix(hexColorLeftWithHash, hexColorRightWithHash, weight) {
  if (weight === void 0) {
    weight = 50.0;
  }

  var mixedColor = '#';
  var hexColorLeft = hexColorLeftWithHash.substring(1);
  var hexColorRight = hexColorRightWithHash.substring(1);

  var decimalToHex = function decimalToHex(d) {
    return d.toString(HEX_BASE);
  };

  var hexToDecimal = function hexToDecimal(h) {
    return parseInt(h, HEX_BASE);
  }; // loop through each of the 3 hex channels: red, green, and blue


  var leftChannel;
  var rightChannel;
  var mixedChannel;

  for (var i = 0; i <= 5; i += CHANNEL_LENGTH) {
    leftChannel = hexToDecimal(hexColorLeft.substr(i, CHANNEL_LENGTH));
    rightChannel = hexToDecimal(hexColorRight.substr(i, CHANNEL_LENGTH)); // combine the current channel from each source color according to the specified weight

    mixedChannel = decimalToHex(Math.floor(rightChannel + (leftChannel - rightChannel) * (weight / 100.0))); // each channel must be 2 digits for the final hex color

    while (mixedChannel.length < CHANNEL_LENGTH) {
      mixedChannel = "0" + mixedChannel;
    }

    mixedColor += mixedChannel;
  }

  return mixedColor;
};

var colorLevel = function colorLevel(color, level) {
  var base = level > 0 ? '#000000' : '#ffffff';
  var absLevel = Math.abs(level);
  return mix(base, color, absLevel * COLOR_LEVEL_STEP);
};

var modularColor = function modularColor(index, level, theme) {
  // lighten and darken colors alternately to create more distinction for
  // series that have more than 5 items
  var adjustedLevel = level + Math.floor(index / COLOR_MOD) * COLOR_MOD_SPACING * (Math.floor(index / COLOR_MOD) % 2 === 0 ? -1 : 1);

  switch (index % COLOR_MOD) {
    case 0:
      return theme.colorLevel(theme.primary, adjustedLevel);

    case 1:
      return theme.colorLevel(theme.secondary, adjustedLevel);

    case 2:
      return theme.colorLevel(theme.tertiary, adjustedLevel);

    case 3:
      return theme.colorLevel(theme.quaternary, adjustedLevel);

    case 4:
      return theme.colorLevel(theme.quinary, adjustedLevel);

    default:
      return theme.colorLevel(theme.textTertiary, adjustedLevel);
  }
};

var media = Object.keys(breakpoints).reduce(function (acc, label) {
  acc[label] = function (first) {
    var args = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }

    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      @media (min-width: ", "em) {\n        ", "\n      }\n    "], ["\n      @media (min-width: ", "em) {\n        ", "\n      }\n    "])), breakpoints[label] / FONT_REM_SIZE, css.apply(void 0, __spreadArrays([first], args)));
  };

  return acc;
}, {}); // TODO: Cleanup and do programmatically

export var sidebarWidthAdjust = function sidebarWidthAdjust(property, themedProps) {
  return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), themedProps.theme.media.xs(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ": ", ""], ["", ": ", ""])), property, themedProps.theme.sideBarWidthXs), themedProps.theme.media.sm(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ": ", ""], ["", ": ", ""])), property, themedProps.theme.sideBarWidthSm), themedProps.theme.media.md(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ": ", ""], ["", ": ", ""])), property, themedProps.theme.sideBarWidthMd), themedProps.theme.media.xl(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ": ", ""], ["", ": ", ""])), property, themedProps.theme.sideBarWidthXl));
};
export var contentWidthAdjust = function contentWidthAdjust(property, themedProps) {
  return css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), themedProps.theme.media.xs(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ": ", ""], ["", ": ", ""])), property, themedProps.theme.contentWidthXs), themedProps.theme.media.sm(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ": ", ""], ["", ": ", ""])), property, themedProps.theme.contentWidthSm), themedProps.theme.media.md(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ": ", ""], ["", ": ", ""])), property, themedProps.theme.contentWidthMd), themedProps.theme.media.xl(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ": ", ""], ["", ": ", ""])), property, themedProps.theme.contentWidthXl));
};
/* ================================= THEMES ================================= */
// Global theming for 1st party apps, setting fonts and sizes

export var GlobalTheme = createGlobalStyle(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    html {\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n    }\n\n    body #fiducius-root {\n        font-family: ", ";\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n    }\n"], ["\n    html {\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n    }\n\n    body #fiducius-root {\n        font-family: ", ";\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n    }\n"])), function (p) {
  return p.theme.media.xs(templateObject_12 || (templateObject_12 = __makeTemplateObject(["font-size: 11px;"], ["font-size: 11px;"])));
}, function (p) {
  return p.theme.media.sm(templateObject_13 || (templateObject_13 = __makeTemplateObject(["font-size: 12px;"], ["font-size: 12px;"])));
}, function (p) {
  return p.theme.media.md(templateObject_14 || (templateObject_14 = __makeTemplateObject(["font-size: 13px;"], ["font-size: 13px;"])));
}, function (p) {
  return p.theme.media.lg(templateObject_15 || (templateObject_15 = __makeTemplateObject(["font-size: 14px;"], ["font-size: 14px;"])));
}, function (p) {
  return p.theme.media.xl(templateObject_16 || (templateObject_16 = __makeTemplateObject(["font-size: 15px;"], ["font-size: 15px;"])));
}, function (p) {
  return p.theme.fontFamilySansSerif;
}, function (p) {
  return p.theme.media.xs(templateObject_17 || (templateObject_17 = __makeTemplateObject(["font-size: 11px;"], ["font-size: 11px;"])));
}, function (p) {
  return p.theme.media.sm(templateObject_18 || (templateObject_18 = __makeTemplateObject(["font-size: 12px;"], ["font-size: 12px;"])));
}, function (p) {
  return p.theme.media.md(templateObject_19 || (templateObject_19 = __makeTemplateObject(["font-size: 13px;"], ["font-size: 13px;"])));
}, function (p) {
  return p.theme.media.lg(templateObject_20 || (templateObject_20 = __makeTemplateObject(["font-size: 14px;"], ["font-size: 14px;"])));
}, function (p) {
  return p.theme.media.xl(templateObject_21 || (templateObject_21 = __makeTemplateObject(["font-size: 15px;"], ["font-size: 15px;"])));
}); // Fiducius Light

export var light = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({
  themeName: 'light'
}, colors), layout), borders), boxShadows), font), input), breakpoints), {
  media: media,
  contentWidthAdjust: contentWidthAdjust,
  sidebarWidthAdjust: sidebarWidthAdjust,
  colorLevel: colorLevel,
  modularColor: modularColor,
  mix: mix
}); // Fiducius Light

export var newlight = __assign(__assign({}, light), {
  themeName: 'newlight',
  primaryA: '#29a090',
  primaryB: '#5ddca1'
}); // Fiducius Dark

var darkColors = {
  // Text Colors
  textPrimary: '#f5f5f5',
  textSecondary: '#ececec',
  textTertiary: '#adadad',
  lowContrast: '#343a40'
  /* '#343331', '#343434', '#343a40', */
  ,
  highContrast: '#f8f9fa'
  /* '#f8f7f5', '#f8f8f8', '#f8f9fa', */
  ,
  primaryA: '#29a090',
  primaryB: '#5ddca1',
  // Background depth levels
  // WIP: https://coolors.co/433e3c-3a3533-2f2a28-2c2725-231e1c // orange tint
  // WIP: https://coolors.co/3c3c3c-333333-282828-252525-1c1c1c // neutral
  // WIP: https://coolors.co/3c3e43-33353a-282a2f-25272c-1c1e23 // blue tint
  level0: '#3c3e43'
  /* '#3f3e3c', '#3c3c3c', '#3c3e43', */
  ,
  level1: '#33353a'
  /* '#363533', '#333333', '#33353a', */
  ,
  level2: '#282a2f'
  /* '#2b2a28', '#282828', '#282a2f', */
  ,
  level3: '#25272c'
  /* '#282725', '#252525', '#25272c', */
  ,
  level4: '#1c1e23'
  /* '#1f1e1c', '#1c1c1c', '#1c1e23', */
  ,
  level0B: '#3c3e43'
  /* '#3f3e3c', '#3c3c3c', '#3c3e43', */
  ,
  level1B: '#444444'
  /* '#363533', '#333333', '#33353a', */
  ,
  level2B: '#282a2f'
  /* '#2b2a28', '#282828', '#282a2f', */
  ,
  level3B: '#25272c'
  /* '#282725', '#252525', '#25272c', */
  ,
  level4B: '#1c1e23'
  /* '#1f1e1c', '#1c1c1c', '#1c1e23', */

};
export var dark = __assign(__assign(__assign({}, light), {
  themeName: 'dark'
}), darkColors); // Example Bees

var beesColors = {
  // Theme colors
  primary: '#665500',
  secondary: '#7f6a00',
  tertiary: '#997f00',
  quaternary: '#b29400',
  quinary: '#ccaa00',
  // Text Colors
  textPrimary: '#665500',
  textSecondary: '#7f6a00',
  textTertiary: '#997f00',
  // Background depth levels
  level0: '#fcffe0',
  level1: '#fbffd6',
  level2: '#faffcc',
  level3: '#f9ffc1',
  level4: '#f9ffb7'
};
export var bees = __assign(__assign(__assign({}, light), {
  themeName: 'bees'
}), beesColors); // Example Grass

var grassColors = {
  // Theme colors
  primary: '#216600',
  secondary: '#2a7f00',
  tertiary: '#329900',
  quaternary: '#3bb200',
  quinary: '#43cc00',
  // Text Colors
  textPrimary: '#216600',
  textSecondary: '#216600',
  textTertiary: '#2a7f00',
  // Background depth levels
  level0: '#eaffe0',
  level1: '#e3ffd6',
  level2: '#ddffcc',
  level3: '#d6ffc1',
  level4: '#cfffb7'
};
export var grass = __assign(__assign(__assign({}, light), {
  themeName: 'grass'
}), grassColors); // Example Water

var waterColors = {
  // Theme colors
  primary: '#002d66',
  secondary: '#00397f',
  tertiary: '#004499',
  quaternary: '#0050b2',
  quinary: '#005bcc',
  // Text Colors
  textPrimary: '#002d66',
  textSecondary: '#00397f',
  textTertiary: '#004499',
  // Background depth level
  level0: '#e0eeff',
  level1: '#d6e8ff',
  level2: '#cce2ff',
  level3: '#c1ddff',
  level4: '#b7d7ff'
}; // Example Water

export var water = __assign(__assign(__assign({}, light), {
  themeName: 'water'
}), waterColors);
var greenlightColors = {
  // Theme colors

  /*primary: '#00662d',
  secondary: '#007f39',
  tertiary: '#009944',
  quaternary: '#00b250',
  quinary: '#00cc5b',*/
  primaryA: '#29a090',
  primaryB: '#5ddca1',
  // Text Colors
  textPrimary: '#00662d',
  textSecondary: '#41a090',
  textTertiary: '#ffffff',
  // Background depth level
  level0: '#57b3a8',
  level1: '#29a090',
  level2: '#ccffe2',
  level3: '#edeff2',
  level4: '#b7ffd7',
  //Secondary background colors for gradients
  level0B: '#57b3a8',
  level1B: '#5ddca1',
  level2B: '#ccffe2',
  level3B: '#edeff2',
  level4B: '#b7ffd7'
}; // Example Water

export var greenlight = __assign(__assign(__assign({}, light), {
  themeName: 'greenlight'
}), greenlightColors);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22;